import { useState as t, useEffect as o } from "react";
import { isSSR as r } from "../helpers/isSSR.js";
const w = () => r() ? {
  width: 0,
  height: 0
} : {
  width: window.innerWidth,
  height: window.innerHeight
};
function d() {
  const [i, n] = t(w());
  return o(() => {
    const e = () => {
      n({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    return e(), window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e);
    };
  }, []), i;
}
export { d as useWindowSize };